import React, { Component } from 'react';
import { List } from 'semantic-ui-react';

export default class SlotContent extends Component {

    render() {
        const {equipment} = this.props;

        if(!equipment) {
            return null;
        }

        let type = '';

        if(equipment.WeaponType) {
            type = equipment.WeaponType;
        } else if(equipment.ArmorType) {
            type = equipment.ArmorType;
        } else if(equipment.EssenceType) {
            type = equipment.EssenceType;
        }

        return (
            <List>
                <List.Item>
                    <List.Content floated='right'>
                        {type}
                    </List.Content>
                    <List.Content>
                        {equipment.Slot}
                    </List.Content>
                </List.Item>
            </List>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/SlotContent.jsx